function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "things-break_svg__a",
  x1: "50%",
  x2: "43.492%",
  y1: "-15.907%",
  y2: "41.117%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#7D009C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7D009C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "things-break_svg__g",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#A313B4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#5A086B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "things-break_svg__i",
  x1: "50%",
  x2: "43.492%",
  y1: "-17.805%",
  y2: "40.861%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "things-break_svg__o",
  x1: "45.71%",
  x2: "96.976%",
  y1: "50%",
  y2: "6.024%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00919F"
})), /*#__PURE__*/React.createElement("path", {
  id: "things-break_svg__c",
  d: "M12.595 79.799l-2.203-17.026-2.269-14.816 11.605-10.591 4.713-18.67L23.62.339l17.106 6.435 9.064 10.521L64.5 32.056l5.498 36.623-28.763 49.759H5.677L0 97.151z"
}), /*#__PURE__*/React.createElement("path", {
  id: "things-break_svg__f",
  d: "M18.845 77.299l-2.203-17.026-2.269-14.816 11.605-10.591 4.713-18.67L32.306.838 21.915 20.913l-2.94 13.217L8.423 48.618l.06 24.784-7.938 27.117 11.382 15.419L6.25 94.651z"
}), /*#__PURE__*/React.createElement("path", {
  id: "things-break_svg__k",
  d: "M84.97 0l-6.73 37.778v38.446l10.51 21.673 12.498 26.478-6.246-29.622-6.88-20.241 3.75-28.262 5.678-35.625 7.709-8.125 27.865 5.938 35.626 41.25 7.811 52.187-22.5 46.25-32.5 23.125-40.625 6.875-46.877-15.314S1.868 113.436.934 113.436c-.623 0 .211-16.874 2.501-50.624L22.811 32.5l37.5-24.063L84.968 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "things-break_svg__n",
  d: "M7.469 0L0 34.014l.74 42.21 8.44 21.953 14.568 26.198-6.246-29.622L9.18 82.482V61.224L6.433 47.947l5.951-20.529-1.134-16.793L27.759 2.5z"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "things-break_svg__e",
  cx: "41.754%",
  cy: "-1.618%",
  r: "89.709%",
  fx: "41.754%",
  fy: "-1.618%",
  gradientTransform: "matrix(.0121 .99993 -1.00622 .01246 .396 -.433)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "47.165%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.986%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "things-break_svg__m",
  cx: "50%",
  cy: "8.396%",
  r: "83.448%",
  fx: "50%",
  fy: "8.396%",
  gradientTransform: "matrix(0 1 -.99225 0 .583 -.416)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0.361
}), /*#__PURE__*/React.createElement("stop", {
  offset: "47.165%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.986%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "things-break_svg__q",
  cx: "50%",
  cy: "8.396%",
  r: "83.448%",
  fx: "50%",
  fy: "8.396%",
  gradientTransform: "matrix(0 1 -.99225 0 .583 -.416)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "47.165%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.986%"
})), /*#__PURE__*/React.createElement("filter", {
  id: "things-break_svg__b",
  width: "113%",
  height: "113.3%",
  x: "-6.5%",
  y: "-6.7%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 2.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "things-break_svg__j",
  width: "109.3%",
  height: "109.4%",
  x: "-4.7%",
  y: "-4.7%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 2.5
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-7 -10)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(131 94.395)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 57.75,
  cy: 131.542,
  fill: "url(#things-break_svg__a)",
  filter: "url(#things-break_svg__b)",
  opacity: 0.551,
  rx: 57.5,
  ry: 56.25
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(84 55.585 69.375)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "things-break_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#things-break_svg__c"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.125,
  cy: 61.25,
  fill: "#742097",
  mask: "url(#things-break_svg__d)",
  rx: 56.875,
  ry: 56.25
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.125,
  cy: 61.25,
  fill: "url(#things-break_svg__e)",
  mask: "url(#things-break_svg__d)",
  opacity: 0.337,
  rx: 56.875,
  ry: 56.25
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(84 57.322 64.654)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "things-break_svg__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#things-break_svg__f"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.373,
  cy: 58.438,
  fill: "url(#things-break_svg__g)",
  mask: "url(#things-break_svg__h)",
  rx: 56.875,
  ry: 56.25
}))), /*#__PURE__*/React.createElement("ellipse", {
  cx: 88.123,
  cy: 249.375,
  fill: "url(#things-break_svg__i)",
  filter: "url(#things-break_svg__j)",
  opacity: 0.349,
  rx: 80.625,
  ry: 80
}), /*#__PURE__*/React.createElement("mask", {
  id: "things-break_svg__l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#things-break_svg__k"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 88.123,
  cy: 90.625,
  fill: "#23C386",
  mask: "url(#things-break_svg__l)",
  rx: 80.625,
  ry: 80
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 88.123,
  cy: 90.625,
  fill: "url(#things-break_svg__m)",
  mask: "url(#things-break_svg__l)",
  opacity: 0.295,
  rx: 80.625,
  ry: 80
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(77.5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "things-break_svg__p",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#things-break_svg__n"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.623,
  cy: 90.625,
  fill: "url(#things-break_svg__o)",
  mask: "url(#things-break_svg__p)",
  rx: 80.625,
  ry: 80
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.623,
  cy: 90.625,
  fill: "url(#things-break_svg__q)",
  mask: "url(#things-break_svg__p)",
  opacity: 0.152,
  rx: 80.625,
  ry: 80
})));

function SvgThingsBreak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 243 237"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgThingsBreak as ReactComponent };